module.exports = __webpack_public_path__ + "img/5.dfa2b995.jpg";